import { Folder } from '../server/folder';

export class FavoritesRefreshEvent {
    public constructor(public folder: Folder) {}
}
